import React from 'react'
import { Text, TextVariant } from '@mprolab/uikit'
import { useTheme } from 'styled-components'
import { useTranslation } from 'react-i18next'
import { ClaimProgress } from 'views/Rewards/types'

interface RewardInfoBoxProps {
  progress: ClaimProgress
}

const RewardInfoBox: React.FC<RewardInfoBoxProps> = ({ progress }) => {
  const { t } = useTranslation()
  const { colors } = useTheme()

  const getRewardInfoContent = () => {
    switch (progress) {
      case ClaimProgress.CONFIRMING:
        // case ClaimProgress.SUCCESS:
        return (
          <Text variant={TextVariant.BODY_SMALL} color={colors.gray6}>
            {t('stakingPanel.claimApprove')}
          </Text>
        )
      default:
        return <></>
    }
  }
  return <>{getRewardInfoContent()}</>
}

export default RewardInfoBox
